import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "innerProps", "selectProps"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
import React from "react";
import { components } from "react-select";
export var GenericSelectControlSingleValue = function (_ref) {
  var isDisabled = _ref.isDisabled,
    innerProps = _ref.innerProps,
    selectProps = _ref.selectProps,
    rest = _objectWithoutProperties(_ref, _excluded),
    genericSelectStyles = selectProps.genericSelectStyles,
    customProps = function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
          _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
        });
      }
      return e;
    }({
      "aria-disabled": isDisabled
    }, innerProps);
  return React.createElement(components.SingleValue, _extends({}, rest, {
    className: genericSelectStyles.SingleValue,
    innerProps: customProps
  }));
};
GenericSelectControlSingleValue.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "GenericSelectControlSingleValue"
}, GenericSelectControlSingleValue.__docgenInfo = {
  componentName: "GenericSelectControlSingleValue",
  packageName: "@jutro/components",
  description: "",
  displayName: "GenericSelectControlSingleValue",
  methods: [],
  actualName: "GenericSelectControlSingleValue"
};